import React from 'react'
import { Button } from 'src/components'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import { SavedAnimal } from '../components/SavedAnimal'
import { useStyles } from './styles'

interface OffspringSectionProps {
  tipoReproducao: string
  savedBirths: any[]
  isLoadingAnimal: boolean
  handleOpenDiagnosisModal: () => void
  handleRemoveBirth: (index: number) => void
}

export const OffspringSection: React.FC<OffspringSectionProps> = ({
  tipoReproducao,
  savedBirths,
  isLoadingAnimal,
  handleOpenDiagnosisModal,
  handleRemoveBirth
}) => {
  const style = useStyles()

  return (
    <section className={`${style.section} ${style.diagnosisSection}`}>
      <div className={style.sectionHeader}>
        <h2 className={style.sectionTitle}>Crias</h2>
        {tipoReproducao && savedBirths.length > 0 && (
          <Button
            type='button'
            className={`${style.buttonWrapper} ${style.buttonOutlined}`}
            onClick={handleOpenDiagnosisModal}
            disabled={isLoadingAnimal}
            outlined
          >
            Adicionar Cria
          </Button>
        )}
      </div>
      {savedBirths.length === 0 ? (
        <div className={style.pendingDiagnosisContainer}>
          <div className={style.pendingDiagnosisContent}>
            <InfoOutlinedIcon className={style.pendingDiagnosisIcon} />
            <span className={style.pendingDiagnosisText}>Nenhuma cria adicionada</span>
          </div>
          {tipoReproducao && (
            <Button
              type='button'
              className={style.buttonWrapper}
              onClick={handleOpenDiagnosisModal}
              disabled={isLoadingAnimal}
            >
              Adicionar Cria
            </Button>
          )}
        </div>
      ) : (
        <div className={style.diagnosisInfoContainer}>
          {savedBirths.map((birth, index) => (
            <SavedAnimal
              key={`birth-${index}`}
              savedBirthAnimal={birth}
              index={index}
              onRemove={() => handleRemoveBirth(index)}
            />
          ))}
        </div>
      )}
    </section>
  )
}
